// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__8onoy","map_title_style":"MapPOIS_map_title_style__D82Vh"};